import { useQuery } from '@tanstack/react-query';

import { useMetaApiInstance } from '../api';
import { HOST_QUERY_KEY } from '../constants';

import type { UseQueryOptions } from '@tanstack/react-query';
import type { Region, ServiceMeta } from '../constants';

export type UseKeywordMetadataOptions = UseQueryOptions<ServiceMeta>;

/**
 * 지정한 서비스 키워드와 리전에 대한 메타데이터 정보를 제공합니다.
 * @description
 * - Meta Api의 fetchKeywordMetadata 응답을 react-query로 제공합니다.
 * - SSR을 지원할 수 있도록 stable queryKey를 사용합니다.
 * - region이 없으면 API 요청 시 global로 조회합니다.
 */
const useKeywordMetadata = (
  serviceKeyword: string,
  region?: Region,
  options?: UseKeywordMetadataOptions,
) => {
  const { fetchKeywordMetadata } = useMetaApiInstance();

  return useQuery<ServiceMeta>({
    queryKey: [HOST_QUERY_KEY.GET_KEYWORD_ENDPOINT, { serviceKeyword, region }],
    queryFn: () => fetchKeywordMetadata({ serviceKeyword, region }),
    enabled: !!serviceKeyword,
    staleTime: Infinity,
    ...options,
  });
};

export default useKeywordMetadata;
